import React from "react";
import "./Css/Footer.css";
import { MapPin, Phone, Mail } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* LEFT SECTION */}
        <div className="footer-section">
          <h2 className="title">ग्रामपंचायत तासगांव</h2>
          <p className="subtitle">मू. पो. तासगांव ता.– जि. सातारा</p>

          <h3 className="subheading">संपर्क माहिती</h3>

          <div className="info-item">
            <MapPin className="icon" />
            <div>
              <h4>ग्रामपंचायत कार्यालय, तासगांव</h4>
              <p>तासगांव, तालुका – सातारा, जिल्हा – सातारा, महाराष्ट्र – (४१५ ००४)</p>
            </div>
          </div>

          <div className="info-item">
            <Phone className="icon" />
            <div>
              <h4>फोन</h4>
              <p>+91 9172554563</p>
            </div>
          </div>

          <div className="info-item">
            <Mail className="icon" />
            <div>
              <h4>ईमेल</h4>
              <p>grap.tasgaon@gmail.com</p>
            </div>
          </div>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-section">
          <h2 className="title">झटपट लिंक्स</h2>

          <ul className="links">
            <li onClick={() => navigate("/")}>मुख्यपृष्ठ</li>
           <li onClick={() => navigate("/locationinfo")}>आमच्याविषयी</li>
            <li onClick={() => navigate("/yashogatha")}>यशोगाथा / उपक्रम</li>
         <li onClick={() => navigate("/gallary")}>गॅलरी</li>
             <li onClick={() => navigate("/abhiyan")}>मुख्यमंत्री अभियान</li>
          </ul>
        </div>

        {/* OFFICE TIME */}
        <div className="footer-section">
          <h2 className="title">कार्यालयीन वेळा</h2>

          <p>महिन्यातील प्रत्येक सोमवार ते शुक्रवार</p>
          <p>सकाळी १०.१५ ते संध्याकाळी ६.१५</p>
          <p className="sunday">रविवार: बंद</p>
        </div>
      </div>

      <hr className="footer-line" />

      <div className="footer-bottom">
        <p>©2025 by grampanchayattasgaon.</p>
        <div className="policies">
          <p>Privacy Policies</p>
          <p>Terms and Conditions</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
